var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ltr"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.links),function(link,idx){return _c('tr',{key:idx},[_c('td',[_vm._v(_vm._s(link.content))]),_c('td',[_c('WhatsAppLink',{attrs:{"phoneNumber":_vm.applicant.phone_number,"message":link.template,"blocked":!!_vm.applicant.blocked}})],1)])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }